import * as React from 'react'
// components
import Header from '../components/layouts/Header'
import Footer from '../components/layouts/Footer'
import HomeHero from '../components/sections/HomeHero'
import HomeHeroVisuals from '../components/sections/HomeHeroVisuals'
import IntelligenceLayer from '../components/sections/IntelligenceLayer'
import PlatformArchitecture from '../components/sections/PlatformArchitecture'
import SpotlightComponent from '../components/sections/Spotlight'
import OurClientsComponent from '../components/sections/OurClients'
import SovereignIntelligence from '../components/sections/SovereignIntelligence'
import StrategicAlignment from '../components/sections/StrategicAlignment'
import WorkforceVisibility from '../components/sections/WorkforceVisibility'
import WorkforcePathways from '../components/sections/WorkforcePathways'
import WorkforceInsights from '../components/sections/WorkforceInsights'
import StrategicClarityCTA from '../components/sections/StrategicClarityCTA'

const Home = () => {
  return (
    <>
      <div id='smooth-wrapper'>
        <div id='smooth-content'>
          <div className='podio'>
            <section>
              <HomeHero />
            </section>
            <section>
              <HomeHeroVisuals />
            </section>
            <section id='overview'>
              <IntelligenceLayer />
            </section>
            <section>
              <PlatformArchitecture />
            </section>
            <section>
              <SpotlightComponent />
            </section>
            <section>
              <StrategicAlignment />
            </section>
            <section>
              <WorkforceVisibility />
            </section>
            <section>
              <WorkforcePathways />
            </section>
            <section>
              <WorkforceInsights />
            </section>
            <section>
              <SovereignIntelligence />
            </section>
            <section id='our-clients'>
              <OurClientsComponent />
            </section>
            <section>
              <StrategicClarityCTA />
            </section>
            <Footer />
          </div>
        </div>
      </div>
      <Header />
    </>
  )
}

export default Home
